import * as React from 'react'
import { Box } from '@mui/material'

const Container = ({ children, style, w, isRow }) => {
  return (
    <Box
      sx={{
        width: '100%',
        pl: w ? 0 : 1,
        pt: w ? 1 : 0,
        display: 'flex',
        flexDirection: isRow ? 'row' : 'column',
        maxWidth: w ? '100%' : 'calc(100% - 200px)',
        ...style,
      }}>
      {children}
    </Box>
  )
}

export default Container
